<template>
    <div class="app_container">
        <el-form :rules="rules" ref="form" :model="form" label-width="100px" class="event-form">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="所在位置" prop="location">
                        <el-select v-model="form.location" placeholder="请选择"  filterable>
                            <el-option v-for="item in locationList" :key="item.id" :label="item.cname"
                                       :value="item.ename"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="是否项目" prop="is_project">
                        <el-radio-group v-model="form.is_project" @change="radioEvent">
                            <el-radio  :label=true>是</el-radio>
                            <el-radio  :label=false>否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="form.is_project">
                    <el-form-item label="项目名称" prop="project_name">
                        <el-select v-model="form.project_name" placeholder="请选择" filterable @change="projectNameEvent">
                            <el-option v-for="item in projectName" :key="item.id" :label="item.cname" :value="item.ename"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="资源类型" prop="resource_type">
                        <el-select clearable v-model="form.resource_type" placeholder="请选择" @change="resourceTypeEvent" :disabled="type=='edit'">
                            <el-option v-for="item in resourceType" :key="item.id" :label="item.alias"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="资源数量" prop="resource_count">
                        <el-input-number v-model="form.resource_count" :precision="0"  :min="1" label="描述文字"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="background:#F5F7FA;margin-bottom:10px;padding-top:10px;">
                <attrForm :attrData="attrData" :specification="form.specification" :type="type" ref="attrForm"></attrForm>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="使用人" prop="user">
                        <div>
                            <el-input type="text"
                                      placeholder="请选择"
                                      disabled v-model="applyUser"
                                      class="form-common mr10"></el-input>
                            <router-link :to="{ path:'/reporterList',query: {enable:true, callback:getReporter} }">
                                <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                            </router-link>
<!--                            <el-button type="primary" :type="userTasksTotal>=5?'danger':'success'" plain >人员繁忙度  ({{userTasksTotal}})</el-button>-->
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" v-if="form.is_project">
                    <el-form-item label="项目二线" prop="project_user">
                        <div>
                            <el-input type="text" placeholder="请选择项目二线" disabled v-model="projectUserName" class="form-common mr10"></el-input>
                            <router-link :to="{ path:'/requesterList',query: { callback:(val)=>getRequester(val,'projectUser') } }">
                                <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                            </router-link>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="" prop="">

                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="计划完成时间" prop="end_time">
                        <el-date-picker
                            v-model="form.end_time"
                            type="datetime"
                            placeholder="选择日期时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            class="form-common"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="用途">
                        <el-input type="textarea" v-model="form.purpose"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="form.comment"></el-input>

<!--                        <ueditor v-model="form.description" :config="myConfig" :key="1" :value="2" @ready="editorReady"></ueditor>-->
                    </el-form-item>
                </el-col>
            </el-row>

        <el-form-item v-if="type == 'add'">
            <el-button type="primary" size="small" @click="submit('create_commit')" :disabled="isSubmit">{{ type == "edit" ? '确定' : "创建并提交"}}</el-button>
            <el-button type="primary" size="small" @click="submit('create')" :disabled="isSubmit">{{ type == "edit" ? '确定' : "创建"}}</el-button>
            <el-button type="default" size="small" @click="onCancel">取消</el-button>
        </el-form-item>
        <el-form-item v-else>
            <el-button type="primary" size="small" @click="submit('create')" :disabled="isSubmit">{{ type == "edit" ? '确定' : ""}}</el-button>
            <el-button type="default" size="small" @click="onCancel">取消</el-button>
        </el-form-item>

        </el-form>
    </div>
</template>

<script>

    import services from "./resourceApply.service";
    import commonService from "../../services/common.service"
    // import relevancyTab from "../common/relevancyTab.vue"
    import attrForm from './components/attrForm.vue'

    // import knowledge from "../../components/knowledge.vue"
    // import inputFile from "../common/inputFile.vue"
    // import ueditor from "../../components/ueditor.vue"

    import { getRules } from "./resourceApply.rules";
    const rules = getRules();
    export default {
        props:{
            type:{
                type:String,
                default:"add"
            },
            serialNumber:String,
            parentNumber:String,
            callback:Function,
            parentParams:Object,
        },
        components:{ attrForm},
        data() {
            return {
                rules:rules,
                formName:"form",
                form:{
                    location:"",
                    is_project:false,
                    project_name:"",
                    resource_type:'',
                    specification:null,
                    resource_count:"1",
                    project_user:'',
                    user:'',
                    end_time:'',
                    purpose:"",
                    comment:"",
                    handle:"",
                },
                projectUserName:'',
                isSubmit:false,
                attrData:[],
                applyUser:'',
                editMode:true,


            }
        },
        created() {

        },
        mounted(){
            if(this.type!=='edit'&&!this.parentNumber){
                // this.getDefaultUser()
            }
            if(this.type == "edit"){
                this.$modal.title = "修改资源申请"
                this.editMode=false
                setTimeout(()=>{
                    this.$store.dispatch('getResourceType')
                    this.getDetail()
                },100)
            }
            // if (this.parentNumber) {
            //     this.$modal.title='提交为变更'
            //     if (this.parentParams){
            //         setTimeout(()=>{
            //             this.getCmdbService()
            //         },100)
            //     }else{
            //         setTimeout(()=>{
            //             this.getDetails()
            //         },100)
            //     }
            // }
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            // 位置
            locationList(){
                return this.dictionary.location
            },
            //项目名称
            projectName(){
                return this.dictionary.project_name
            },
            //资源类型
            resourceType(){
                return this.$store.state.resourceTypeList
            }
        },
        methods: {
            // 是否项目
            radioEvent( val ){
                if(!val){
                    this.form.project_name = ''
                }

            },
            //改变项目名称
            projectNameEvent(val){
                // console.log(val)
                // console.log(this.projectName)
                let data = this.projectName.filter((item,index)=>{
                    return item.ename == val
                })
                // console.log(data)
                this.form.project_user = data[0].user_id
                this.projectUserName = data[0].user_name
            },
            // 选择的请求人
            getRequester(obj,str){
                // console.log(obj,'选择请求人[0]');
                // console.log(obj)
                if(str == 'projectUser'){
                    this.form.project_user = obj.internalUserid
                    this.projectUserName = obj.name
                }
                // else{
                //     this.requesterInfo = {
                //         id:obj.internalUserid,
                //         name:obj.name,
                //         department:obj.department.id
                //     };
                //     this.form = {
                //         ...this.form,
                //         requesterName: obj.name,
                //         department:obj.department.id
                //     }
                //
                // }

            },
            //资源类型切换
            resourceTypeEvent(val){

                services.getResourceTypeAttr({type_id:val}).then(res => {
                    // console.log(res)
                    this.attrData = res
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            // 选择的使用人
            getReporter(obj){
                this.form.user = obj.internalUserid
                this.applyUser = obj.name
            },
            //详情
            getDetail(){
                services.getResourceApplyDetail({serial_number:this.serialNumber}).then(res=>{
                    this.form.serial_number = res.serial_number
                    this.form.location =  res.location
                    this.form.is_project = res.is_project
                    this.form.project_name = res.project_name
                    this.form.resource_type = Number(res.resource_type)
                    this.form.specification = {...res.specification}
                    this.form.resource_count = res.resource_count
                    this.form.user = res.user.userid
                    this.form.end_time = res.end_time
                    this.form.purpose = res.purpose
                    this.form.comment = res.comment
                    this.applyUser = res.user.name
                    this.form.project_user = res.project_user.userid?res.project_user.userid:'';
                    this.projectUserName = res.project_user.name?res.project_user.name :'';
                    this.resourceTypeEvent(this.form.resource_type)
                    // console.log(this.form)
                })
            },
            submit(handleStr){
                // console.log(this.$refs.attrForm)
                let formName = this.formName;
                this.$refs[formName].validate((valid) => {
                    if(valid){
                        let modelRules = this.$refs.attrForm.onSubmit()
                        if(modelRules){
                            this.isSubmit=true
                            let params = {
                                ...this.form,
                                specification:{
                                    ...this.$refs.attrForm.modelValue,
                                },
                                handle:handleStr
                            }
                            if(this.type == 'edit'){
                                this.updateResourceApply(params)
                            }else{
                                this.addResourceApply(params)
                            }
                            console.log(params)
                            // this.updateResourceApply(params)

                        }else{
                            return false
                        }
                    }else{
                        this.isSubmit=false
                        this.$message.error('✳为必填项，请全部填写')
                    };
                    return valid;
                })
            },

            // 创建资源申请
            addResourceApply(params){

                    services.resourceApplyAdd(params).then(res => {
                        this.$message.success("申请成功");
                        this.close(true);
                    }).catch(err => {
                        this.isSubmit=false
                        this.$message.error(err.message);
                    })

            },
            // 修改变更
            updateResourceApply(params){
                services.resourceApplyEdit(params).then(res => {
                    this.$message.success("修改成功");
                    this.close(true);
                }).catch(err => {
                    this.isSubmit=false
                    this.$message.error(err.message);
                })
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },


        }
    }
</script>

<style scoped lang="scss"  rel="stylesheet/scss">

</style>
